import { Link, Navigate, useParams } from 'react-router-dom';
import { articlesForProject } from '../../content/wechat';
import { getResearchProject } from '../../content/research-projects';
import { formatDay } from '../../shared/format';

export default function ResearchProject() {
  const { projectId } = useParams<{ projectId: string }>();
  const project = getResearchProject(projectId);
  if (!project) return <Navigate to="/" replace />;
  const list = articlesForProject(project.id);
  const planned = project.status === 'planned';

  return (
    <div className="project-page">
      <div className="project-hero">
        <a
          className="project-cover"
          href={project.cover}
          target="_blank"
          rel="noreferrer"
          title="查看大图"
        >
          <img src={project.cover} alt={project.title} />
        </a>
        <div className="project-hero-body">
          <div className="eyebrow">{project.kicker}</div>
          <h1>{project.title}</h1>
          <p className="project-summary">{project.summary}</p>
          <div className="badge-row">
            <span className={`badge ${planned ? 'warn' : 'ok'}`}>
              {planned ? '筹备中' : '已开展'}
            </span>
            {project.tags.map((tag) => (
              <span key={tag} className="badge">
                {tag}
              </span>
            ))}
          </div>
          {project.metrics.length ? (
            <div className="project-metrics">
              {project.metrics.map((metric) => (
                <div key={metric.label}>
                  <b>{metric.value}</b>
                  <span>{metric.label}</span>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>

      <section className="project-intro">
        {project.intro.map((paragraph) => (
          <p key={paragraph.slice(0, 12)}>{paragraph}</p>
        ))}
      </section>

      {planned ? (
        <section className="project-plan">
          <div className="section-head">
            <div>
              <div className="eyebrow">Plan</div>
              <h2>拟开展内容</h2>
            </div>
            <span className="badge warn">筹备中</span>
          </div>
          <ol className="plan-list">
            {(project.plan ?? []).map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ol>
          <p className="planned-note">该方向尚未发表文章，论文与实验正在准备中。</p>
        </section>
      ) : (
        <section className="project-articles">
          <div className="section-head">
            <div>
              <div className="eyebrow">Articles</div>
              <h2>相关研究</h2>
            </div>
            <span className="muted">{list.length} 篇公众号文章</span>
          </div>

          {list.length ? (
            <div className="article-list">
              {list.map((article) => (
                <Link
                  key={article.id}
                  to={`/research/${project.id}/${article.id}`}
                  className="article-card"
                >
                  <div className="article-thumb">
                    {article.cover ? (
                      <img src={article.cover} alt="" />
                    ) : (
                      <span>{formatDay(article.date)}</span>
                    )}
                  </div>
                  <div className="article-card-body">
                    <div className="article-meta">
                      {article.date}
                      {article.primary === project.id ? '' : ' · 相关研究'}
                    </div>
                    <h3>{article.title}</h3>
                    <p>{article.summary}</p>
                    <span className="article-link">阅读全文 →</span>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className="empty">
              <b>相关内容整理中</b>
              这个方向的文章还在归档。
            </div>
          )}
        </section>
      )}

      <div className="project-foot">
        <Link to="/#research" className="btn btn-ghost">
          返回研究方向
        </Link>
        <Link to="/" className="btn btn-ghost">
          返回首页
        </Link>
      </div>
    </div>
  );
}